export const StepStatus = {
  Completed: 'Completed',
  InProgress: 'InProgress',
  NotStarted: 'NotStarted',
} as const;

export type StepStatusType = (typeof StepStatus)[keyof typeof StepStatus];
